export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_03.cf585fe0.jpg";